module.exports = __webpack_public_path__ + "img/icons B_20.ef3bc964.png";